import { render, staticRenderFns } from "./investorContactUs.vue?vue&type=template&id=4beb980c"
import script from "./investorContactUs.vue?vue&type=script&lang=js"
export * from "./investorContactUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports